module.exports = __webpack_public_path__ + "img/Gärtnerinnen.8e7fe4b6.svg";